module.exports = __webpack_public_path__ + "img/lunbotu2.8475d1f8.png";